import { render } from "./ItemEmpresaView.vue?vue&type=template&id=d790d31a&ts=true"
import script from "./ItemEmpresaView.vue?vue&type=script&lang=ts"
export * from "./ItemEmpresaView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__